import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import { ExternalLink } from '@/assets/icons'
import { useTheme } from '@/hooks/useTheme'
import { useBoxoBannersList, BoxoBannerItem } from './useBoxoBannersList'

const BoxoBannerCard: React.FC<BoxoBannerItem & { cardWidth: number }> = ({
  title,
  description,
  backgroundImage,
  onPress,
  cardWidth,
}) => {
  const theme = useTheme()

  return (
    <BaseView
      onClick={onPress}
      style={{
        // width: `${cardWidth}px`,
        width: '100%',
        minHeight: '120px',
        borderRadius: '20px',
        padding: '16px',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundColor: theme.colors.background.cardItemRoot,
        cursor: 'pointer',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <BaseText
        fontSize={16}
        fontFamily="semibold"
        color="label.default"
        style={{ maxWidth: '180px', lineHeight: '20px' }}
      >
        {title}
      </BaseText>

      <BaseView
        row
        align="center"
        gap={6}
        px={10}
        py={6}
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          borderRadius: '16px',
          alignSelf: 'flex-start',
        }}
      >
        <BaseText fontSize={14} fontFamily="medium" color="label.default">
          {description}
        </BaseText>
        <ExternalLink size={10} color="#fff" />
      </BaseView>
    </BaseView>
  )
}

export const BoxoBanners: React.FC = () => {
  const bannersList = useBoxoBannersList()
  const visibleBannersList = bannersList.filter((banner) => banner.isVisible)

  if (visibleBannersList.length === 0) {
    return null
  }

  const cardWidth =
    visibleBannersList.length > 1
      ? window.innerWidth * 0.85 - 24
      : window.innerWidth - 48

  return (
    <BaseView
      style={{
        marginTop: '20px',

        overflow: 'hidden',
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: '12px',
          overflowX: 'auto',
          scrollSnapType: 'x mandatory',
          // paddingLeft: '12px',
          // paddingRight: '12px',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
        className="hide-scrollbar"
      >
        {visibleBannersList.map((banner) => (
          <BoxoBannerCard key={banner.id} {...banner} cardWidth={cardWidth} />
        ))}
      </div>
      <style>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </BaseView>
  )
}
